module.exports = __webpack_public_path__ + "img/lf_icon.91fc861a.png";